import { DateTime } from 'luxon';

export const getFormattedTransactionDate = isoDate =>
  DateTime.fromISO(isoDate).toLocaleString(DateTime.DATETIME_MED);

export const getCustomerName = customer =>
  !!customer?.firstName ? `${customer.firstName} ${customer.lastName}` : '';

export const getRefundsTotal = (refunds = []) =>
  refunds.reduce((result, refund) => result + refund.refundAmount, 0);

export const getRefundableAmount = (chargeAmount, refunds) =>
  chargeAmount > 0 ? chargeAmount - getRefundsTotal(refunds) : chargeAmount;
